import { render, staticRenderFns } from "./DealSummary.vue?vue&type=template&id=046da21a&scoped=true&"
import script from "./DealSummary.vue?vue&type=script&lang=js&"
export * from "./DealSummary.vue?vue&type=script&lang=js&"
import style0 from "./DealSummary.vue?vue&type=style&index=0&id=046da21a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046da21a",
  null
  
)

export default component.exports